import { Text } from '@fluentui/react-components';

interface IPermissionsFieldProps {
  label: string;
  children: React.ReactNode[] | React.ReactNode;
}

export function PermissionsField({ children, label }: IPermissionsFieldProps) {
  return (
    <div style={{ display: 'grid' }}>
      <Text style={{ marginBottom: '2px' }}>{label}</Text>
      {children}
    </div>
  );
}
